import { useHubMethod } from '@Contexts/signal';
import { useCallback } from 'react';
import { MessagingConstants } from '@Model';

export function useRemoteCacheInvalidation(watchedResourceName: string, onInvalidate: () => void) {
    const refetch = useCallback(
        (resourceNames: string) => {
            const names = JSON.parse(resourceNames);
            if (Array.isArray(names) && names.includes(watchedResourceName)) {
                onInvalidate();
                return;
            }
        },
        [onInvalidate, watchedResourceName],
    );

    useHubMethod(MessagingConstants.invalidate_cache, refetch);
}
